import { useStore } from '@tanstack/react-store';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  hubspotManagementStore,
  hydrate,
} from '../stores/hubspotManagementStore';

export function useHubspotUrlSync() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearchParamsRef = useRef(new URLSearchParams(searchParams));
  const [hasHydratedFromUrl, setHasHydratedFromUrl] = useState(false);

  const filters = useStore(hubspotManagementStore, (state) => state.filters);
  const sorting = useStore(hubspotManagementStore, (state) => state.sorting);
  const pagination = useStore(
    hubspotManagementStore,
    (state) => state.pagination,
  );
  const selectedTicketId = useStore(
    hubspotManagementStore,
    (state) => state.ui.selectedTicketId,
  );
  const primarySort = sorting[0];

  useEffect(() => {
    const initialSearchParams = initialSearchParamsRef.current;

    hydrate({
      page: Number.parseInt(initialSearchParams.get('page') || '1', 10),
      pipeline: initialSearchParams.get('pipeline') || '',
      requestType: initialSearchParams.get('requestType') || '',
      source: initialSearchParams.get('source') || '',
      assignee: initialSearchParams.get('assignee') || '',
      search: initialSearchParams.get('search') || '',
      sortColumn: initialSearchParams.get('sortColumn') || '',
      sortDirection: initialSearchParams.get('sortDirection') || '',
      ticketId: initialSearchParams.get('ticketId'),
    });

    setHasHydratedFromUrl(true);
  }, []);

  useEffect(() => {
    if (!hasHydratedFromUrl) {
      return;
    }

    const params = new URLSearchParams();

    if (pagination.currentPage > 1) {
      params.set('page', pagination.currentPage.toString());
    }

    if (filters.pipeline) {
      params.set('pipeline', filters.pipeline);
    }

    if (filters.requestType) {
      params.set('requestType', filters.requestType);
    }

    if (filters.source) {
      params.set('source', filters.source);
    }

    if (filters.assignee) {
      params.set('assignee', filters.assignee);
    }

    if (filters.search) {
      params.set('search', filters.search);
    }

    if (primarySort) {
      params.set('sortColumn', primarySort.id);
      params.set('sortDirection', primarySort.desc ? 'desc' : 'asc');
    }

    if (selectedTicketId) {
      params.set('ticketId', selectedTicketId);
    }

    setSearchParams(params, { replace: true });
  }, [
    filters.pipeline,
    filters.requestType,
    filters.source,
    filters.assignee,
    filters.search,
    primarySort?.desc,
    primarySort?.id,
    pagination.currentPage,
    selectedTicketId,
    hasHydratedFromUrl,
    setSearchParams,
  ]);

  return hasHydratedFromUrl;
}
